import { Button, Flex } from "@gravity-ui/uikit";
import { POIZON_API_BOT_LINK } from "src/constants/links";
import { useGravityDevice } from "src/hooks/useGravityDevice";
import { T, useTranslate } from "src/i18n";

import { TextSection } from "../TextSection";
import { RoadMapSlider } from "./components";

export const HowWeWork = () => {
  const { isMobile } = useGravityDevice();

  const { t } = useTranslate();

  return (
    <Flex
      id="about"
      direction={"column"}
      width={"100%"}
      maxWidth={"1440px"}
      style={{
        paddingLeft: isMobile ? 30 : 50,
        paddingRight: isMobile ? 30 : 50,
        gap: 60,
      }}
    >
      <TextSection
        title={t("landing.how_we_work_block.title", "Как мы работаем?")}
        description={t(
          "landing.how_we_work_block.description",
          "Описание пользовательского пути на нашем сервисе, от регистрации до запуска магазина",
        )}
      />

      <RoadMapSlider />
      <Button
        href={POIZON_API_BOT_LINK}
        target="_blank"
        view="flat-action"
        size="xl"
        width="max"
        selected
        style={{ maxWidth: isMobile ? "100%" : 300, margin: "0 auto" }}
      >
        <T
          keyName={"landing.how_we_work_block.button"}
          defaultValue={"Узнать подробнее"}
        />
      </Button>
    </Flex>
  );
};
